import { AI_VERIFICATION_TYPES } from "@redotech/redo-return-core-common/return-flow/ai-verification-registry";
import * as z from "zod";

export const classifyClaimImage = {
  name: "classifyClaimImage" as const,
  input: z.object({
    imageUrl: z.string(),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    verificationType: z.enum(AI_VERIFICATION_TYPES as [string, ...string[]]),
    itemDetails: z.string().optional(),
    itemImageUrl: z.string().optional(),
    strictness: z.number().optional(),
  }),
  output: z.object({
    category: z.string().nullable(),
    confidence: z.number().optional(),
    reason: z.string(),
  }),
};
